import { getActionAuthorization } from '@selectors/commons/utils';

const INTERNAL_INVOICE_ACTIONS = {
  INTRA_COMMUNITY_SUPPLY: 'invoice:internal:intra-community-supply',
};

export const canCreateIntraCommunityInvoice = (actions) =>
  getActionAuthorization(actions, INTERNAL_INVOICE_ACTIONS.INTRA_COMMUNITY_SUPPLY);
